import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd.min.js'

import PageView from 'front/components/PageView/PageView.js'
import Slider from 'front/components/Slider/Slider.js'

import './IndexPage.css'
import template from './IndexPage.jinja'

var IndexPage = PageView.extend({
    el: '.IndexPage',

    type: 'Index',

    template: template,

    apiUrl: '/api/pages/index/',

    playIn() {
        this.slider.activateTitle()
            .then(() => {
                return this.slider.activateImage()
            })
            .then(() => {
                app.views.nav.activate();
                app.views.cookie.activate();
                this.slider.activateFrame()
                app.views.logo.activate({delay: 500})
                this.slider.activateCounter()
                return app.views.langs.activate({delay: 500})
            })
            .then(() => {
                this.slider.activateArrows()

                setTimeout(() => {
                    app.els.$body.removeClass('u-NoOverflow')
                    this.slider.refresh()
                }, 800)
            })
    },

    playOut() {
        app.views.langs.deactivate()
        app.views.logo.deactivate()
        this.slider.deactivateCounter()
        this.slider.deactivateArrows()

        return Promise.resolve(this.slider.deactivateImage())
            .then(() => {
                this.slider.deactivateTitle()
                return app.views.nav.deactivate()
            })
    },

    prepare () {
        this.$el[0].style.display = 'block'

        this.slider = this.views.slider = new Slider({
            el: this.$('.Slider')
        })

        $.Velocity.hook(this.slider.$firstTitle, 'opacity', '0')
        $.Velocity.hook(this.slider.$firstImg, 'opacity', '0')
        $.Velocity.hook(this.slider.$counter, 'opacity', '0')

        this.slider.$arrows.addClass('isNotActive')
        this.slider.$frame.addClass('isNotActive')

        return this.preloadImages()
            .then(()=> {
                return this.promise
            })
            .then(() => {
                app.els.$window.scrollTop(0)
                return app.loader.deactivate()
            })
    },

    cleanUp () {
        app.els.$body.addClass('u-NoOverflow')
        this.close()
        return app.loader.activate()
    }
})

export default IndexPage



// WEBPACK FOOTER //
// ./assets/app/front/pages/IndexPage/IndexPage.js